/** Magic prefix written to NFC tags (защитная последовательность). */
export const NFC_TAG_PREFIX = "BTP-SCUD:";

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function isUuid(value) {
  return typeof value === "string" && UUID_RE.test(value.trim());
}

export function formatNfcTagPayload(guid) {
  const id = String(guid || "").trim();
  if (!isUuid(id)) {
    throw new Error("Некорректный GUID для NFC-метки");
  }
  return `${NFC_TAG_PREFIX}${id}`;
}

export function parseNfcTagPayload(raw) {
  const text = String(raw || "").trim();
  if (!text) {
    return { valid: false, guid: null, hasProtectivePrefix: false, legacy: false };
  }

  if (text.startsWith(NFC_TAG_PREFIX)) {
    const guid = text.slice(NFC_TAG_PREFIX.length).trim();
    if (isUuid(guid)) {
      return { valid: true, guid, hasProtectivePrefix: true, legacy: false };
    }
    return { valid: false, guid: null, hasProtectivePrefix: true, legacy: false };
  }

  if (isUuid(text)) {
    return { valid: true, guid: text, hasProtectivePrefix: false, legacy: true };
  }

  return { valid: false, guid: null, hasProtectivePrefix: false, legacy: false };
}

export function normalizeNfcTagId(raw) {
  const parsed = parseNfcTagPayload(raw);
  return parsed.valid ? parsed.guid : null;
}
